/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar3 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar3", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M14.939,21.734 c-1.646,0-2.754-0.898-2.817-2.28h1.709c0.024,0.537,0.459,0.869,1.138,0.869c0.635,0,1.074-0.361,1.074-0.889 c0-0.542-0.415-0.874-1.099-0.874H14.08v-1.235h0.864c0.601,0,0.996-0.337,0.996-0.85s-0.386-0.83-1.011-0.83 c-0.615,0-1.03,0.366-1.05,0.918h-1.626c0.024-1.377,1.079-2.256,2.715-2.256c1.562,0,2.637,0.786,2.637,1.924 c0,0.811-0.542,1.45-1.333,1.597v0.093c0.972,0.103,1.592,0.742,1.592,1.65C17.864,20.845,16.663,21.734,14.939,21.734z M24,10H6V6 h18V10z" />
      </svg>
    );
  }
}

IconCalendar3.defaultProps = {
  className: null
};

IconCalendar3.propTypes = {
  className: PropTypes.string
};

export default IconCalendar3;
